import { cn } from "@/lib/utils";

/**
 * A rubber-stamp mark. Green = VERIFIED (confirmed facts, harvest confirms, used-fact lineage);
 * steel = UNCONFIRMED. Rotated ~-6deg, stencil, letterspaced, uppercase.
 * Stamp green ONLY ever means verified/confirmed — never decorative.
 * See .flow/DESIGN-SPEC.md § signature elements.
 */
export interface StampProps {
  children: React.ReactNode;
  tone?: "verified" | "unconfirmed";
  className?: string;
}

export function Stamp({ children, tone = "verified", className }: StampProps) {
  const color = tone === "verified" ? "#2F9E44" : "#8A94A6";
  return (
    <span
      className={cn(
        "inline-flex items-center font-stencil uppercase leading-none select-none",
        className,
      )}
      style={{
        color,
        border: `1.5px solid ${color}`,
        borderRadius: 4,
        padding: "3px 7px",
        fontSize: "10px",
        letterSpacing: "0.14em",
        transform: "rotate(-6deg)",
      }}
    >
      {children}
    </span>
  );
}

export default Stamp;
